/** Advance order status — uses dispatchOrder when moving to Dispatched (creates dispatch record). */
export async function advanceOrderStatus(api, orderId, status, order) {
  if (status === 'Dispatched') {
    if (order?.paymentMethod === 'Online Payment' && order?.paymentStatus !== 'Verified') {
      throw new Error('Online payment must be verified before dispatch');
    }
    return api.dispatchOrder(orderId);
  }
  if (status === 'Confirmed' && order?.paymentMethod === 'Online Payment' && order?.paymentStatus !== 'Verified') {
    throw new Error('Online payment must be verified before confirming order');
  }
  return api.updateOrderStatus(orderId, status);
}
